import React from 'react';
import { Channel_CODE_SET } from '../../../../config/CgmCodeSet';
import { REPORT_TYPE_SET } from '../../../../config/ReportOptionSet';
import Linker from '../../linker/Linker';
import * as path from '../../../../route/PathConfig';

import './CustomManagerInformation.css';

const QueryTypeIcon = (props) => {
  switch (props.query_type) {
    case "BASIC":{
      return(
        <span className="type_basic">
          {props.query_type}
        </span>
      )
    }
    case "BOOLEAN":{
      return(
        <span className="type_bool">
        {props.query_type}
      </span>
      )
    }
    default:
      return null;
  }
}

const ReportTypeIcon = (props) => {
  switch (props.report_type) {
    case "volume":{
      return(
        <span className="type_volu">
          {REPORT_TYPE_SET[props.report_type]}
        </span>
      )
    }
    case "sentiment":{
      return(
        <span className="type_sent">
          {REPORT_TYPE_SET[props.report_type]}
        </span>
      )
    }
    case "source":{
      return(
        <span className="type_sour">
          {REPORT_TYPE_SET[props.report_type]}
        </span>
      )
    }
    case "relation":{
      return(
        <span className="type_wordcloud">
          {REPORT_TYPE_SET[props.report_type]}
        </span>
      )
    }
    case "category":{
      return(
        <span className="type_cate">
          {REPORT_TYPE_SET[props.report_type]}
        </span>
      )
    }
    case "positioningmap":{
      return(
        <span className="type_positioning">
          {REPORT_TYPE_SET[props.report_type]}
        </span>
      )
    }
    case "buzzlist":{
      return(
        <span className="type_buzzlist">
          {REPORT_TYPE_SET[props.report_type]}
        </span>
      )
    }
    default:
      return null;
  }
}

const CustomManagerInformation = (props) => {
  return (
    <div id="reportInformation">
      <div id="reportTitBtn">
        <div id="reportTit">커스텀 리포트 정보</div>
        {/* <div id="custom-manageBtn"> */}
        <div id="manageBtn">
          <Linker path={`${path.CUSTOMREPORTEDIT}/${props.selectedCustom.customID}`}>
            <a className="button purple_line">편집</a>
          </Linker>
          &nbsp;
          <a className="button purple_line"  onClick={()=>console.log(props.selectedCustom.customID)}>삭제</a>
          &nbsp;
          <Linker path={`${path.CUSTOMREPORTRESULT}/${props.selectedCustom.customID}`}>
            <a className="button purple" >실행</a>
          </Linker>
        </div>
      </div>
      {props.selectedCustomQueryArray.map(report=>{
        return(
          <div className="buzzReport">
            <table className="buzzTablesty">
              <tr>
                <td colSpan="2">
                  <span className="buzzTxt">
                    {report.name}
                  </span>
                  &nbsp;
                    <ReportTypeIcon report_type={report.REPORT_TYPE} />
                  &nbsp;                </td>
              </tr>
              <tr>
                <td width="14%" className="tit">Date</td>
                <td width="86%">
                  {`${JSON.parse(report.content).date[0].toString().replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3')} ~ ${JSON.parse(report.content).date[1].toString().replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3')}`}
                </td>
              </tr>
              <tr>
                <td className="tit">Channel</td>
                <td>
                  {JSON.parse(report.content).channels.map((item,index,array)=>{
                    if (index == array.length-1){
                      return(
                        <>{Channel_CODE_SET[item]}</>
                      )
                    }
                    else{
                      return(
                        <>{Channel_CODE_SET[item]},&nbsp;</>
                      )
                    }
                  })}
                </td>
              </tr>
              <tr>
                <td className="tit">Base Keyword</td>
                  {props.queryData.info.filter(item=>item.queryID==report.mainQuery).map(item=>{
                    return(
                      <td>
                        <strong>{item.name}</strong>&nbsp;<QueryTypeIcon query_type={item.QUERY_TYPE} />
                      </td>
                    )
                  })}
              </tr>
              {report.subQuery.length == 0 ? undefined:
                <tr>
                  <td className="tit">Sub Keyword</td>
                  <td>
                    {report.subQuery.map(subQueryItem=>{
                      return(
                        <>
                          {props.queryData.info.filter(item=>item.queryID==subQueryItem.queryID).map((item, index, array)=>{
                            if (index == report.subQuery.length-1){
                              return(
                                <>
                                  {item.name}&nbsp;<QueryTypeIcon query_type={item.QUERY_TYPE} />
                                </>
                              )
                            }
                            else{
                              return(
                                <>
                                  {item.name}&nbsp;<QueryTypeIcon query_type={item.QUERY_TYPE} />,&nbsp;&nbsp;
                                </>
                              )
                            }
                          })}
                        </>
                      )})}
                  </td>
                </tr>}
            </table>
          </div>
          )
        })}
    </div>
  )
}

export default CustomManagerInformation;